
export default {

    getRules(context, success, error) {
        context.$http.get('repricing').then(success, error)
    },

    getOne(context, id, success, error) {
        context.$http.get('repricing/' + id).then(success, error)
    },

    create(context, rule, success, error) {
        context.$http.post('repricing', rule).then(success, error)
    },

    update(context, rule, id, success, error) {
        context.$http.put('repricing/' + id, rule).then(success, error)
    },
    
    remove(context, id, success, error){
        context.$http.delete('repricing/' + id).then(success, error)
    },
}


// WEBPACK FOOTER //
// ./src/services/repricing/index.js